import React from 'react'
import './index.less'
const PageNoFount = React.memo(() => {
    return <div className='page-404'><span>404</span>页面未找到！</div>
})
export default PageNoFount